module.exports = __webpack_public_path__ + "assets/images/passengers_phase4.05675c86ca34c6d1932615385f97ca2e.svg";